<template>
  <div class="step__block-doortype">
    <div><span>Design:</span></div>
    <p class="step__block-doortype-title">{{ kompasDesignType.title }}</p>
    <!-- <select-dict
      v-model="mountStructureType"
      :select-list="mountsTypes"
      :select-first-item="true"
    /> -->
  </div>
</template>

<script setup lang="ts">
import { computed, defineModel } from "vue";

const kompasDesignTypes = [
  { qty: 0, title: "Custom 0 lines" },
  { qty: 1, title: "Standard 1 line" },
  { qty: 2, title: "Custom 2 lines" },
  { qty: 3, title: "Custom 3 lines" },
  { qty: 4, title: "Custom 4 lines" },
  { qty: 5, title: "Custom 5 lines" },
  { qty: 6, title: "Custom 6 lines" },
  { qty: 7, title: "Custom 7 lines" },
  { qty: 8, title: "Custom 8 lines" },
  { qty: 9, title: "Custom 9 lines" },
  { qty: 10, title: "Custom 10 lines" },
];

const lines = defineModel<number>("lines");
const kompasDesignType = computed(() => {
  return (
    kompasDesignTypes.find((type) => type.qty === lines.value) ||
    kompasDesignTypes[1]
  );
});
</script>

<style lang="scss" scoped>
.step__block-doortype {
  display: grid;
  grid-template-columns: minmax(0, max-content) 316px;
  column-gap: 10px;
  color: #404d63;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 15px;
}

.step__block-doortype-title {
  color: #404d63;
  font-family: Gilroy;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.step__block-doortype--transform {
  padding-top: 15px;
}

.step__block-doortype div:first-child {
  align-self: center;
  justify-self: center;
}
</style>
